export const MESSAGES = {
    ERROR_WHILE_RETRIEVING_DATA: 'An error occurred while retrieving the data.',
};



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/messages.ts